module.exports = __webpack_public_path__ + "media/images/tokyo_tour_zh-hans01-6b50abd00436f91b667781e85d01e9b1.jpg";